import { Api } from '@/api';
import { AuthHttpService } from '../../auth/services';
import type { IHttpClient } from '@/services/http';

/**
 * Auth API Base Class (Framework Agnostic)
 * 
 * Base class for API endpoints that require authentication.
 * Uses AuthHttpService which automatically adds Bearer token to requests.
 */
export abstract class AuthApi extends Api {
  private _authHttpService: AuthHttpService;

  protected constructor() {
    super();
    this._authHttpService = new AuthHttpService();
  }

  protected override get api(): IHttpClient {
    return this._authHttpService.api;
  }

  /**
   * Create an abort controller for request cancellation
   */
  protected createAbortController(): AbortController {
    return this._authHttpService.createAbortController();
  }
}
